import CrudActionContainer from './CrudActionContainer';
import SupportItemController from '../controllers/SupportItemController';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import commonHandler from '../errorHandlers/common-handler';
import { getActionHookBuilder } from './action-hook-builder';

class SupportItemsCRUDActions extends CrudActionContainer {
  publishAction: string;

  constructor() {
    super('SUPPORT_ITEMS');

    this.publishAction = super.makeActionKey('PUBLISH');
  }

  retrieveAll() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const response = await SupportItemController.retrieveAll('overview');
        dispatch(this.retrievedAll(response));
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  publish(
    email: string,
    comment: string,
    name: string,
    assetId?: number | null,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.publishAction));

      try {
        await SupportItemController.publish(email, comment, name, assetId);
        return true;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
}

const supportItemsCRUDActions = new SupportItemsCRUDActions();

export default supportItemsCRUDActions;

export const useSupportItemsCRUDActions = getActionHookBuilder(
  supportItemsCRUDActions,
  ['retrieveAll', 'publish'],
);
